import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 2rem;
  font-weight: 700;
  font-size: 0.9rem;
  gap: 4rem;

  .frete-gratis-tarja {
    padding: 0.3rem 1rem;
    font-weight: 700;
    color: var(--white);
    user-select: none;
    font-size: 1.1rem;
    color: var(--white);
    background: var(--gradient_blue);
    width: 20rem;
  }

  .regulation-info {
    width: 100%;
    max-width: 30rem;
    color: var(--primary_color);
  }

  .link-more-information {
    color: var(--blue_light);
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    .frete-gratis-tarja {
      width: 100%;
      max-width: 20rem;
    }
  }
`;
